import React from 'react';
import {generatePath, useHistory} from "react-router-dom";

export const useRedirect = () => {
    const history = useHistory()

    const redirect = (to, params = {}) => {
        history.push(generatePath(to, params))
    }

    const replace = (to, params = {}) => {
        history.replace(generatePath(to, params))
    }

    return {redirect, replace, history}
}